import httpCustomer from "./httpServiceCustomer";

const apiEndpoint = "/presencas";

export function getCheckin(cod_atleta) {
  return httpCustomer.get(apiEndpoint + "/" + cod_atleta);
}
